module.exports = __webpack_public_path__ + "media/images/site/mailer-c192f2480bd00ff43064a67dfdc48da0.svg";